import { Avatar, ButtonBase, ClickAwayListener, Grid, List, ListItem, ListItemIcon, ListItemText, Tooltip, Typography, useTheme } from '@mui/material';
import stylesLogo from "../Accounts/Account.styles";
import { useState } from 'react';
import sizeFontCustom from "./fontSize.styles"
import { useTranslation } from '../../hooks/useTranslation';
import { getFipLogoAlt } from '../../utils/fipLogo.utils';
import { keyboardFocusVisibleSx } from '../../utils/a11y.utils';

function FipdNotDiscovered(props) {
  const { t } = useTranslation();
  const theme = useTheme()
  const { fipId, customDetails } = props
  const fipName = t(`fips.${global.objectFormatFip[fipId]?.fipId}`);
  
  // Check for dark theme
  const isDark = customDetails?.darkTheme === true || theme.palette.mode === 'dark'
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };
  return (
    <Grid
      item
      xs={6}
      md={6}
    >
      <ClickAwayListener onClickAway={handleTooltipClose}>
        <div>
          <Tooltip
            onClose={handleTooltipClose}
            open={open}
            title={t(`fips.${global.objectFormatFip[fipId]?.fipId}`)}
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -14],
                    },
                  },
                ],
              },
            }}
          >
            <ButtonBase
              sx={{ width: "100%", borderRadius: '14px', ...keyboardFocusVisibleSx }}
              onClick={handleTooltipOpen}
            >
              <ListItem key={fipId} sx={{ maxWidth: "95%" }} disablePadding>
                <ListItemText primary={
                  <List disablePadding >
                    <ListItem sx={{ 
                      m: "0.5rem 1.25rem 0 0", 
                      background: isDark ? '#3D3D3D' : theme.palette.background.paper, 
                      p: "0.5rem", 
                      borderRadius: "14px",
                      border: 'none'
                    }} >
                      <ListItemIcon >
                        <Avatar
                          alt={getFipLogoAlt(fipId, fipName)}
                          src={global.objectFormatFip[fipId]?.productIconUri}
                          sx={{ 
                            ...stylesLogo.avatarStyle, 
                            background: isDark ? '#2D2D2D' : theme.palette.background.paper 
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          <Typography sx={{
                            ...sizeFontCustom.subHeading,
                            color: theme.palette.text.primary,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}>
                            {t(`fips.${global.objectFormatFip[fipId]?.fipId}`)}
                          </Typography>
                        }
                      />
                    </ListItem>
                  </List>
                } />
              </ListItem>
            </ButtonBase>
          </Tooltip>
        </div>
      </ClickAwayListener>
    </Grid>)
}

export default FipdNotDiscovered